import { useEffect } from 'react';

import { IPanorama, PanoramaView } from '@ael/core-api';

/**
 * Synchronizes camera position between panoramas (target position is changed to source).
 * Clean-up causes source position to be changed to target's position.
 *
 * @param sourcePanorama Panorama its current position is used for synchronization.
 * @param targetPanorama Panorama which position is being changed.
 * @param view restricting view where sync can only be done
 */
export const usePanoramaSynchronizeCameraPositions = (
  sourcePanorama: IPanorama | null,
  targetPanorama: IPanorama | null,
  view?: PanoramaView
): void => {
  useEffect(() => {
    if (!sourcePanorama || !targetPanorama) {
      return;
    }

    return () => sourcePanorama.synchronizeCameraPositionTo(targetPanorama);
  }, [view, sourcePanorama, targetPanorama]);
};
